import { tooltipRenderer } from '../сonfig-and-helpers/helpers';
import housingActivityChartOptions from './housing-affordability-chart-options';

/**
 * Class representing the HousingAffordability Chart component.
 */
export default class HousingAffordabilityChart {
    DataPageInstance;
    chartAPI;
    //
    chartSelectChoice;
    //
    options;

    /**
     * Create a HousingAffordabilityChart.
     * @param {Object} DataPageInstance - An instance of the DataPage component.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;
        this.chartAPI = DataPageInstance.chartAPI;

        // Initialize the chart select dropdown.
        this.initializeChartSelect();

        this.resetChartOptions();
        this.chartAPI = agCharts.AgCharts.create(this.options);
    }

    /**
     * Initialize the Chart Select dropdown and set up event handling.
     */
    initializeChartSelect() {
        // Find the select element for Chart.
        const select = document.querySelector('[name=data-charts]');

        // Return if the select element is not found.
        if (!select) {
            return;
        }

        // Create a Choice instance for the select element.
        this.chartSelectChoice = new Choices(select, {
            shouldSort: false,
            itemSelectText: '',
            allowHTML: true,
            searchEnabled: false,
            classNames: {
                containerOuter: 'choices data-pages__chart-select',
                itemDisabled: 'hidden',
            },
        });

        // Add an event listener for the select element.
        select.addEventListener(
            'change',
            this.chartSelectChangeEventHandler.bind(this),
        );
    }

    /**
     * Set chart data and update the chart.
     * @param {Array} rawData - Raw data for the chart.
     */
    setChartData(rawData) {
        if (!rawData) {
            return;
        }

        // Get the active chart options and update the chart data.
        let activeOptions = this.getChartOptions();
        activeOptions = this.getChartTitle(activeOptions);

        activeOptions.data = this.prepareData(rawData);
        activeOptions.series = this.prepareSeries();

        // Update the chart with new data.
        agCharts.AgCharts.update(this.chartAPI, activeOptions);
    }

    prepareData(data) {
        let result = [];
        data.forEach((el) => {
            result.push({
                date_string: el['date_string'],
                hai: Number(el['hai']) ? el['hai'] : null,
                hai_fthb: Number(el['hai_fthb']) ? el['hai_fthb'] : null,
                median_close_price: Number(el['median_close_price'])
                    ? el['median_close_price']
                    : null,
                median_income: Number(el['median_income'])
                    ? el['median_income']
                    : null,
                required_income: Number(el['required_income'])
                    ? el['required_income']
                    : null,
                avg_mortgage_rate: Number(el['avg_mortgage_rate'])
                    ? el['avg_mortgage_rate']
                    : null,
            });
        });

        return result;
    }

    prepareSeries() {
        const chartType = this.chartSelectChoice.getValue();

        // Create an array to store chart series objects
        return [
            {
                yName: chartType.label,
                type: 'line',
                xKey: 'date_string',
                yKey: chartType.value,
                tooltip: { renderer: tooltipRenderer },
            },
        ];
    }

    /**
     * Set the chart title based on selected options.
     * @param {Object} options - Chart options object.
     * @returns {Object} - Updated chart options object.
     */
    getChartTitle(options) {
        let title = '';

        // Get the selected geography` for the title.
        const requestParams = this.DataPageInstance.getGeoRequestParams();
        title += `${requestParams.geoName}`;

        // Get the active series parameters.
        const seriesParams = this.chartSelectChoice.getValue().label;
        title += `: ${seriesParams}`;

        options.title.text = title;

        // Set title for number-type axis
        options.axes[1].title.text = this.chartSelectChoice.getValue().label;

        return options;
    }

    /**
     * Event handler for Chart Select dropdown change.
     */
    chartSelectChangeEventHandler() {
        const value = this.getChartType();
        if (!value) {
            return;
        }

        this.setChartData(this.getRowData());

        this.eventChartSelectChange();
    }

    getChartType() {
        return this.chartSelectChoice.getValue(true);
    }

    /**
     * get the raw data that come from the server
     * @return {*}
     */
    getRowData() {
        return this.DataPageInstance.getRowData();
    }

    /**
     * Get the chart options.
     * @returns {Object} - Chart options object.
     */
    getChartOptions() {
        return this.options;
    }

    /**
     * Reset the chart options and select the default chart.
     */
    resetChartOptions() {
        this.options = housingActivityChartOptions();
        this.chartSelectChoice.setChoiceByValue('hai');
    }

    /**
     * Trigger the 'chartSelect.Change' event.
     */
    eventChartSelectChange() {
        const event = new CustomEvent('chartSelect.Change');

        document.dispatchEvent(event);
    }
}
